import * as ol from 'openlayers';
import { ColorConfig } from '@/gui/color-config';

export class MapDrawInteractionStyles {
    public static shapesDataIdsToActive: boolean[] = [];

    public static returnStyleDuringDraw(feature: any) {
        let style = new ol.style.Style({
            fill: new ol.style.Fill({
                color: ColorConfig.filterResultDarkTransparent
            }),
            stroke: new ol.style.Stroke({
                color: ColorConfig.filterResultDark,
                width: 2
            }),
            image: new ol.style.Circle({
                radius: 7,
                fill: new ol.style.Fill({
                    color: ColorConfig.filterResultDark
                })
            })
        });
        return style;
    }

    public static returnStyleAfterDraw(feature: any) {
        let activeStyle = new ol.style.Style({
            fill: new ol.style.Fill({
                color: ColorConfig.filterResultDarkTransparent
            }),
            stroke: new ol.style.Stroke({
                color: ColorConfig.filterResultDark,
                width: 1
            }),
            image: new ol.style.Circle({
                radius: 7,
                fill: new ol.style.Fill({
                    color: '#ffcc33'
                })
            })
        });
        let inActiveStyle = new ol.style.Style({
            fill: new ol.style.Fill({
                color: 'rgba(0,0,0,0.06)'
            }),
            stroke: new ol.style.Stroke({
                color: 'rgba(0,0,0,0.1)',
                width: 1
            }),
            image: new ol.style.Circle({
                radius: 7,
                fill: new ol.style.Fill({
                    color: '#ffcc33'
                })
            })
        });

        if (MapDrawInteractionStyles.shapesDataIdsToActive[feature.getId()]) {
            return activeStyle;
        } else {
            return inActiveStyle;
        }
    }
}
